import { css } from '@emotion/react';
import styled from '@emotion/styled';

import Card from 'components/global/Card';

import { Breakpoints } from 'utils/const.styles';

// Input

export const FlexCard = styled(Card)`
	flex-direction: column;
	display: flex;
`;

export const InputContainer = styled.div`
	width: 100%;
	position: relative;
	margin-bottom: 1.5rem;
	body[dir='rtl'] & {
		text-align: right;
	}
`;

export const TabContainer = styled.div`
	width: 100%;
	margin-bottom: var(--margin-3);
	display: flex;
	white-space: nowrap;
	min-height: 4.5rem;
	> * {
		flex: 0 0 auto;
	}
	@media ${Breakpoints.tablet && Breakpoints.mobile && Breakpoints.desktop} {
		overflow: auto;
	}

	body[dir='rtl'] & {
		overflow: auto;
		min-height: 5.5rem;
	}
`;

export const TabItemCss = css`
	margin-right: var(--margin-3);
	body[dir='rtl'] & {
		margin-right: unset;
		margin-left: var(--margin-3);
	}
	font-weight: 500;
`;

export const StoresContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(31rem, 1fr));
	max-height: 100%;
	gap: 1rem;
	overflow: auto;
`;
